export type WebConfig = {
    sourcesCols: SourcesCols
    sources: Source[]
    phoneNumbers: PhoneNumber[]
}

export type SourcesCols = {
    lg: number
    md: number
    sm: number
}

export type Source = {
    key: string
    cols?: number
    rows?: number
    order: SourceOrder
    color?: string
    icon?: string
    label: string
    url?: string
    support?: boolean
}

export type SourceOrder = {
    lg?: number
    md?: number
    sm?: number
}

export type PhoneNumber = {
    key: string
    label: string
    phone: string
}

export const emptyWebConfig: WebConfig = {
    sourcesCols: {
        lg: 6,
        md: 4,
        sm: 2
    },
    sources: [],
    phoneNumbers: []
};
